module.exports = __webpack_public_path__ + "static/media/bettr-create-tasks.0e5785bf.png";